import Vue, { createApp } from 'vue';
import App from './App.vue';
import router from '@/router';
import pinia from '@/store';
import 'viewerjs/dist/viewer.css'
import 'ant-design-vue/dist/reset.css';
import 'virtual:svg-icons-register'
import './styles/tailwind.css'
const app = createApp(App);

app.use(pinia);
app.use(router);
app.config.errorHandler = function (err) {
  console.error('未捕获的异常，', err);
};
app.mount('#app');
